import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs"
import localForage from "localforage"

import { Site, SITES } from "@/sites"
import { getApiURL, isProductionEnvironment } from "@/utils"
import { MapLayer } from "@/views/MapView/partials/MapLayers"

import { clearDataOnLogout } from "./user"

type GlobalReduxState = {
  mapLayers: MapLayer[]
  currentSite: Site | null // niepotrzebne w reduksie?
  sites: Site[] // niepotrzebne w reduksie?
  date: string
  // TODO: refactor errors
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors: any[]
}

const initialState: GlobalReduxState = {
  mapLayers: ["online_drivers"],
  date: dayjs().format("YYYY-MM-DD"),
  errors: [],
  currentSite: null,
  sites: isProductionEnvironment ? [SITES[0]] : [...SITES],
}

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMapLayers(state, action: PayloadAction<MapLayer[]>) {
      state.mapLayers = action.payload
    },
    setSites(state, action: PayloadAction<Site[]>) {
      state.sites = action.payload
    },
    setCurrentSite(state, action: PayloadAction<Site>) {
      const currentSiteToSet = action.payload

      localForage.setItem("current_site", currentSiteToSet)
      localForage.setItem("api_url", getApiURL(currentSiteToSet))
      state.currentSite = currentSiteToSet
    },
    setDate(state, action: PayloadAction<string>) {
      state.date = action.payload
    },
    // TODO: refactor errors
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pushError(state, action: PayloadAction<any[] | null>) {
      state.errors.push(action.payload)
    },
    clearErrors(state) {
      state.errors = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearDataOnLogout, () => initialState)
  },
})

export const { setMapLayers, clearErrors, pushError, setCurrentSite, setDate, setSites } = globalSlice.actions
export const globalReducer = globalSlice.reducer
